document.addEventListener("DOMContentLoaded", function () {
    const recentlyViewedContainer = document.getElementById(
      "recently-viewed-container"
    );
    const newsletterContainer = document.querySelector(".newsletter");
  
    if (window.location.pathname.includes("/products/")) {
      const productHandle = window.location.pathname.split("/products/")[1];
  
      if (productHandle) {
        let recentlyViewed =
          JSON.parse(localStorage.getItem("recentlyViewed")) || [];
  
        recentlyViewed = recentlyViewed.filter(
          (handle) => handle !== productHandle
        );
  
        recentlyViewed.unshift(productHandle);
  
        if (recentlyViewed.length > 6) {
          recentlyViewed = recentlyViewed.slice(0, 6);
        }
  
        localStorage.setItem("recentlyViewed", JSON.stringify(recentlyViewed));
      }
    }
  
    const productHandles =
      JSON.parse(localStorage.getItem("recentlyViewed")) || [];
  
    if (productHandles.length > 0) {
      recentlyViewedContainer.style.display = "block";
      if (newsletterContainer && window.innerWidth <= 768) {
        newsletterContainer.style.display = "none";
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(["openForm", "Sz9eWM"]);
      }
    } else {
      recentlyViewedContainer.style.display = "none";
    }
  });